<template>
  <f7-page name="smogovy-system" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Smogový varovný systém</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar tabbar bottom>
      <f7-link tab-link="#tab-smog-map" tab-link-active>Mapa</f7-link>
      <f7-link tab-link="#tab-smog-table" :class="{'iswarning':isWarnings}" >
        Výstrahy
      </f7-link>
    </f7-toolbar>

    <f7-tabs class="wh-100">
      <f7-tab id="tab-smog-map" tab-active @tab:show="onMapTabShow($event)">
        <div class="smog-vystrahy-top-bar vystraha-0 green" v-if="!isPM10above">
          V predchádzajúcom dni neboli na žiadnych staniciach priemerné denné hodnoty PM<sub>10</sub> nad 50 &micro;g/m<sup>3</sup>.
        </div>
        <div class="smog-vystrahy-top-bar vystraha-1 yellow" v-if="isPM10above">
          V predchádzajúcom dni boli na niektorých staniciach priemerné denné hodnoty PM<sub>10</sub> nad 50 &micro;g/m<sup>3</sup>.
        </div>


        <l-map :zoom="zoom"
               :center="center"
               :options="mapOptions"
               ref="mapSmog"
               class="smog-map"
        >
          <l-control-zoom position="bottomright"  ></l-control-zoom>
          <l-tile-layer
              ref="layerBg"
              :url="url"
              :attribution="attribution"
          />
          <l-tile-layer :url="borderUrl" />
          <l-geo-json
              ref="smogDataLauer"
              :geojson="smogGeoJsonData"
              :options="smogGeoJsonOptions"
              :interactive="true"
          />
          <l-geo-json
              ref="smogOkresyLayer"
              :geojson="smogOkresyGeoJson"
              :options-style="styleFunctionOkresy"
              :interactive="false"
          />
          <l-geo-json
              ref="smogORKOLayers"
              :geojson="smogORKOGeoJson"
              :options-style="styleFunctionORKO"
              :interactive="false"
          />

          <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
            <div class="leaflet-bar">
              <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
            </div>
          </l-control>

          <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
            <div class="leaflet-bar">
              <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
            </div>
          </l-control>


        </l-map>

      </f7-tab>
      <f7-tab id="tab-smog-table" @tab:show="onTableTabShow($event)" class="padding-bottom">
        <f7-block strong class="no-padding mt-0 mb-5 no-border-top">
          <template v-if="!isWarnings">
            <f7-block class="padding no-margin-top bg-color-green">
              Riadiace stredisko smogového varovného systému informuje verejnosť, že v súčasnosti nie je na území Slovenska žiadna smogová situácia
            </f7-block>
          </template>
          <template v-else>

            <f7-card v-for="(item, index) in this.smogWarnings" :key="index">

              <f7-card-header :class="'smog-spa-'+item.typ_vystrahy.id"
                              v-html="'<strong>'+item.velicina.html+'</strong> ' +  item.typ_vystrahy.desc">
              </f7-card-header>
              <f7-card-content>
                <strong>Oblasť:</strong>
                <ul class="no-margin mb-1">
                  <li v-for="orko in item.oblasti.orko">{{ orko.nazov_oblasti_rko }}</li>
                  <li v-for="orko in item.oblasti.okresy">{{ orko.nazov_okresu }}</li>
                </ul>
                <div class="mt-1 font-weight-bold">Popis:</div>
                <p class="no-margin">{{ item.text_popis_sk }}</p>
                <template v-if="item.subor !== null">
                  <div class="mt-1 font-weight-bold">Detail:</div>
                  <ul class="mt-0"><li><a :href="baseUrl+'File/oko/vystrahy/nove/'+item.subor.subor_nazov" class="external">
                    <template v-if="item.subor.subor_poznamka_sk !== null">
                      {{ item.subor.subor_poznamka_sk }}
                    </template>
                    <template v-else>
                      Súbor s informáciami
                    </template>
                  </a></li></ul>
                </template>

              </f7-card-content>
              <f7-card-footer class="text-small">
                Platnosť od {{ item.platnost_od*1000 | moment('DD.MM.YYYY HH:mm') }}
                <template v-if="item.platnost_do !== null">
                  do {{ item.platnost_do*1000 | moment('DD.MM.YYYY HH:mm') }}
                </template>
              </f7-card-footer>
            </f7-card>

          </template>
        </f7-block>
      </f7-tab>
    </f7-tabs>

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LImageOverlay, LMarker, LGeoJson, LControlZoom, LControl } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import l_smogORKOGeoJson from "../static/shmu/maps/ORKO_2017_WGS84_lite.min"
import l_smogOkresyGeoJson from "../static/shmu/maps/hranice_okresy3.min"
import geoLocationMixin from "../js/geoLocationMixin";
import shmuMixin from "../js/mixin";

var smog_icn_markers = [];

var defaultStyle = {
  fillColor: 'rgba(0,0,0,0.5)'
};

var yellowStyle = {
  fillColor: 'rgba(255, 255, 1, 0.8)'
};

var redStyle = {
  fillColor: 'rgba(254, 1, 4, 0.8)'
};

var orangeStyle = {
  fillColor: 'rgba(243, 138, 57, 0.8)'
};

var oko_style = {
  fillColor: 'rgba(100, 100, 100, 0)',
  fillOpacity:0,
  weight:0,
};



var okoStyles = {
  '0'        : defaultStyle,
  'red'      : redStyle,
  'orange'   : orangeStyle,
  'yellow'   : yellowStyle,
};


export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LControl
  },
  mixins: [
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      lastUpdated: 0,
      tCheckInterval: null,
      isGeoJsonLoaded: false,
      smogORKOGeoJson: l_smogORKOGeoJson,
      smogOkresyGeoJson: l_smogOkresyGeoJson,
      lastUpdatedSmogListData: 0,
      baseUrl: SHMUconf.SHMU_CORE_URL,
      isPM10above: false,
      isWarnings: false,
      smogWarningAreasForMap: [],
      smogWarnings: [],
      smogGeoJsonDt: null,
      smogGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      smogGeoJsonOptions: {
        onEachFeature:this.openSmogDetailFromFeature,
        pointToLayer: this.makeSmogPoint,
      },
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      zoom: 6.5,
      center: latLng(48.688714, 19.696843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      riversUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/rieky/v2/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',

      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },

    };
  },
  watch: {
    smogGeoJsonData() {

      // ak je pm10 state tak zobrazujeme hlasenie
      let objs = this.smogGeoJsonData.features.filter(item => item.properties.pm10_state === 1);

      if (objs && objs.length > 0) {
        this.isPM10above = true;
      } else {
        this.isPM10above = false;
      }
    },
    smogWarnings() {
      if (this.smogWarnings && this.smogWarnings.length > 0) {
        this.isWarnings = true;
      } else {
        this.isWarnings = false;
      }
    },
  },
  computed:{
    styleFunction() {
      const x_smogGeoJsonData = this.smogGeoJsonData;

      return (feature) => {

        var i_style = defaultStyle;
        if (typeof feature != 'undefined') {
          i_style = okoStyles[feature.properties.prop_state];
          // ak je prekrocene pm10 a zaroven tam nie je vystraha, tak ho dame zlte
          if (feature.properties.color_state === 1 && feature.properties.prop_state === '0') i_style = yellowStyle;
          else if (feature.properties.color_state === 2 && feature.properties.prop_state === '0') i_style = orangeStyle;
          else if (feature.properties.color_state === 3 && feature.properties.prop_state === '0') i_style = redStyle;
        }
        return i_style;
      }

    },
    styleFunctionOkresy() {
      const x_smogWarningAreasForMap = this.smogWarningAreasForMap;

      return (feature) => {
        //console.log('styleFunctionOkresy', feature);

        let  ider = feature.properties.IDN3.toString();
        let i_style = oko_style;
        if (x_smogWarningAreasForMap.length > 0) {
          let obj = x_smogWarningAreasForMap.find(item => item.shape_id === ider);
          if (obj) {
            i_style = obj.params;
          }
        }
        return i_style;

      }
    },
    styleFunctionORKO() {
      const x_smogWarningAreasForMap = this.smogWarningAreasForMap;

      return (feature) => {
        //console.log('styleFunctionORKO => ', feature);

        let  ider = feature.properties.OBEC;
        let i_style = oko_style;
        if (x_smogWarningAreasForMap.length > 0) {
          let obj = x_smogWarningAreasForMap.find(item => item.shape_id === ider);
          if (obj) {
            i_style = obj.params;
          }
        }
        return i_style;
      }
    },
    smogListDataSHMU() {
      let list = this.smogListData.filter(item => item.station.type === 1);
      list.forEach((v) => {
        v.station.pollutants.forEach(item => {
          let exists = this.smogListSHMUPollutants.find(inner => item.pollutant_id === inner.pollutant_id);
          if (!exists) this.smogListSHMUPollutants.push(item);
        });
        this.smogListSHMUPollutants.sort((a, b) => (a.order > b.order) ? 1 : -1)
      });
      return list;
    },
    smogListDataOthers() {
      let list = this.smogListData.filter(item => item.station.type === 2);
      list.forEach((v) => {
        v.station.pollutants.forEach(item => {
          let exists = this.smogListOthersPollutants.find(inner => item.pollutant_id === inner.pollutant_id);
          if (!exists) this.smogListOthersPollutants.push(item);
        });
      });
      this.smogListOthersPollutants.sort((a, b) => (a.order > b.order) ? 1 : -1)
      return list;
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-kvalita-ovzdusia');
    this.$f7.accordion.open('.shmu-i-kvalita-ovzdusia');
    this.$nextTick(() => {
      this.initMap();
    });


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) {
        this.loadSmogGeoJsonData();
      }
    },
    loadSmogGeoJsonData: function() {
      const self = this;
      //console.log('loadZrazkyGeoJsonData')

      self.$f7.dialog.preloader('Načítavam...');
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getgeojson', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.smogGeoJsonData = response.data;
              self.isGeoJsonLoaded = true;
              self.lastUpdated = self.$moment().unix();
              // clearInterval(this.tCheckInterval);
              // this.tCheckInterval = setInterval(this.checkLastUpdated, 5 * 60 * 1000); // overujem kazdych 5 min
              this.loadSmogWarningAreasForMap();

            } else {
              self.$f7.dialog.alert('Nepodarilo sa načítať údaje o kvalite ovzdušia', 'Nastala chyba');
            }
            self.$f7.dialog.close();
          }).catch((error) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });
    },
    loadSmogWarningAreasForMap: function() {
      const self = this;

      //self.$f7.dialog.preloader('Načítavam...');
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getwarningareasformap', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.smogWarningAreasForMap = response.data;
              this.loadSmogWarnings();
            } else {
              self.$f7.dialog.alert('Nepodarilo sa načítať údaje o vydaných výstrahách v smogovom varovnom systéme', 'Nastala chyba');
            }
            //self.$f7.dialog.close();
          }).catch((error) => {
        //self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });
    },
    loadSmogWarnings: function() {
      const self = this;

      // self.$f7.dialog.preloader('Načítavam...');
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getwarnings', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.smogWarnings = response.data;
            } else {
              self.$f7.dialog.alert('Nepodarilo sa načítať údaje o vydaných výstrahách v smogovom varovnom systéme', 'Nastala chyba');
            }
            // self.$f7.dialog.close();
          }).catch((error) => {
        // self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });
    },
    initMap() {
      const self = this;
      //this.$refs.mapZrazky.mapObject.ANY_LEAFLET_MAP_METHOD();
      // console.log('leafLet ZRAZKY init done...')

      this.$$('.leaflet-control-attribution a').each((i,item) => {
        self.$$(item).addClass('external')
      });

      this.$refs.mapSmog.mapObject.on('zoomend', function (e) {
        if (this.getZoom() > 9) {
          self.$$('.i-label').css('visibility', 'visible');
        } else {
          self.$$('.i-label').css('visibility', 'hidden');
        }
      });

      // geolocation
      this.locationMapInitEvents(this, this.$refs.mapSmog.mapObject);


    },
    makeSmogPoint(feature, latlng) {
      const self = this;
      let props = feature.properties;
      //let fillColor = 'rgba(74,142,3,1)';

      let r_style = this.styleFunction(feature);
      let fillColor = r_style.fillColor;

      var point = L.circleMarker(latlng, {
        radius: 6,
        fillColor: fillColor,
        color: "#000",
        weight: 1,
        opacity: 1,
        fillOpacity: 0.9
      });

      let map = this.$refs.mapSmog.mapObject;

      let myIcon = L.divIcon({className: 'i-label', html:props.name, iconAnchor:[100,30]});
      smog_icn_markers[feature.id] = L.marker(latlng, {icon: myIcon}).addTo(map);
      smog_icn_markers[feature.id]._icon.id = feature.id;
      smog_icn_markers[feature.id].on({
        click: function (e) {
          //console.log('clicked', e.target._icon.id);
          let station_id = e.target._icon.id;
          if (station_id && parseInt(station_id) > 0) {
            self.$f7router.navigate('/smogovy-system/' + station_id);
          }

        }
      });


      return point;

    },
    openSmogDetailFromFeature(feature, layer) {
      const self = this;
      layer.on({
        click: function (v) {
          // console.log('clicked', v.target.feature.id);
          let station_id = v.target.feature.id;
          if (station_id && parseInt(station_id) > 0) {
            self.$f7router.navigate('/smogovy-system/' + station_id);
          }
        }
      });

    },

    onMapTabShow(e) {
      this.$refs.mapSmog.mapObject.invalidateSize();
    },
    onTableTabShow(e) {

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.mapSmog.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.mapSmog.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.mapSmog.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    }
  }

};
</script>

<style lang="scss">

.smog-vystrahy-top-bar {
  z-index: 1100;
  position: absolute;
  top: calc(var(--f7-page-navbar-offset, 0px) + var(--f7-page-toolbar-top-offset, 0px) + var(--f7-page-subnavbar-offset, 0px) + var(--f7-page-searchbar-offset, 0px) + var(--f7-page-content-extra-padding-top, 0px));;
  left: 0;
  width:100%;
  text-align:center;
  font-size: 12px;
  line-height:10px;
  color: white;
  padding: 5px 0;

  &.yellow {
    /* background-color: yellow; */
    color: black;
  }
  &.green {
    /* background-color: green; */
    color: black;
  }


}

.smog-table-legenda {
  border-collapse:collapse;
  td, th {
    padding: 3px 5px;
    border-right: 1px solid var(--f7-table-cell-border-color);
    border-collapse:collapse;
    &:first-child { border-left: 0;}
    &:last-child { border-right: 0;}
    height: 20px !important;
    white-space: nowrap;
  }
  th {
    text-align:center;

  }
  td {
    font-size:12px;
  }

}
.smog-table {
  border-collapse: collapse;

  tr {
    border: 0px;
  }

  td, th {
    padding: 3px 5px;
    min-width: 50px;
    border-right: 1px solid var(--f7-table-cell-border-color);
    border-collapse: collapse;
    height: 30px !important;
    &:first-child {
      border-left: 0;
    }

    &:last-child {
      border-right: 0;
    }
  }
  th {
    font-weight: bold !important;
    font-size: 12px !important;
  }

}

.smog-spa-1 {
  background-color: #FF6600;
  color: white;
}

.smog-spa-2 {
  background-color: red;
  color: white;
}

.smog-spa-3 {
  background-color: #FF6600;
  color: white;
}

.smog-spa-4 {
  background-color: red;
  color: white;
}

.smog-spa-5 {
  background-color: yellow;
  color: black;
}

.smog-map {
  width: 100%;
  height: 100%;

  .leaflet-top .leaflet-control {
    margin-top: 40px !important;
  }
}

.i-label2 {
  font-weight: bold;
  color:white;
}

.smog-toolbar {
  text-align: center;
  font-size:0.8em;
  width:100%;
  margin:0;
  padding: 0;
}

#tab-smog-map {
  height:100%;
  width:100%;
}

.iswarning {
  font-weight:bold;
  color:red;
  animation:blinkingText 1.2s infinite;
}

@keyframes blinkingText{
  0%{     color: red;    }
  49%{    color: red; }
  60%{    color: #000; }
  99%{    color: #000;  }
  100%{   color: red;    }
}

.oko_0 {
  background: #00b050 !important;;
}
.oko_1 {
  background: #92d050 !important;;
}
.oko_2 {
  background: #ffff00 !important;;
}
.oko_3 {
  background: #ffc000 !important;;
}
.oko_4 {
  background: #ff0000 !important;;
  color: white !important;
}
.oko_w {
  background: #ffffff !important;
  color: var(--f7-block-strong-text-color) !important;
}
.oko_g {
  background: #e8e8e8 !important;
  color: var(--f7-block-strong-text-color) !important;
}


.position-sticky  {
  position: -webkit-sticky;
  position: sticky;
}
.top-0 {
  top: 0;
}


</style>
